import React, { useState } from "react";
import {
    Button,
    Card,
    Col,
    OverlayTrigger,
    Row,
    Table,
    Tooltip,
    Container,
    Spinner,
    Form,
} from "react-bootstrap";
import CustomSearchBox from "components/Shared/CustomSearchBox";
import { getPermission } from "utils/Permissions.js";
import { MOVEMENTS_MASS_BOOK_IN } from "constants/Permissions";

function MovementsProductTable(props) {
    const [summaryView, setSummaryView] = useState(true);

    const SearchStyle = {
        marginTop: "-35px",
        marginLeft: "245px",
    };
    const btnStyle = {
        marginTop: "-50px",
        marginLeft: "61%",
    };

    const renderTableData = () => {
        if (summaryView) {
            // Group the data by productId
            const groupedData = props.MovementsProductData.reduce((acc, log) => {
                const {
                    productId,
                    productName,
                    sku,
                    quantity,
                    sent,
                    received,
                    bookedInUserName,
                    bookedOutUserName,
                } = log;

                // If the productId already exists, aggregate the values
                if (!acc[productId]) {
                    acc[productId] = {
                        productId,
                        productName,
                        sku,
                        quantity: 0,
                        sent: 0,
                        received: 0,
                        bookedInUserNames: new Set(),
                        bookedOutUserNames: new Set(),
                    };
                }

                // Aggregate quantities, sent, received
                acc[productId].quantity += quantity;
                acc[productId].sent += sent;
                acc[productId].received += received;

                // Add unique bookedInUserName and bookedOutUserName
                acc[productId].bookedInUserNames.add(bookedInUserName);
                acc[productId].bookedOutUserNames.add(bookedOutUserName);

                return acc;
            }, {});

            // Convert grouped data to an array for rendering
            const groupedDataArray = Object.values(groupedData);

            return (
                <>
                    {groupedDataArray.map((group, index) => (
                        <tr key={`GroupedProduct${index}`}>
                            <td onClick={() => props.handleGetItemCard(group.productId)}>
                                <a href="#id">{group.sku}</a>
                            </td>
                            <td>{group.productName}</td>
                            <td>{group.quantity}</td>
                            <td>{group.sent}</td>
                            <td>{Array.from(group.bookedOutUserNames).join(", ")}</td>
                            <td>{group.received}</td>
                            <td>{Array.from(group.bookedInUserNames).join(", ")}</td>
                            <td></td>
                        </tr>
                    ))}
                </>
            );
        } else {
            // Render single view
            return props.MovementsProductData.length > 0 &&
                props.MovementsProductData.map((log, index) => {
                    const {
                        productName,
                        sku,
                        productId,
                        id,
                        movementId,
                        quantity,
                        sent,
                        received,
                        bookedInUserName,
                        bookedOutUserName,
                    } = log;
                    return (
                        <tr key={`MovementsProduct${index}`}>
                            <td onClick={() => props.handleGetItemCard(productId)}>
                                <a href="#id">{sku}</a>
                            </td>
                            <td>{productName}</td>
                            <td>{quantity}</td>
                            <td>{sent}</td>
                            <td>{bookedOutUserName}</td>
                            <td>{received}</td>
                            <td>{bookedInUserName}</td>
                            <td>
                                {props?.SingleMovement?.statusId === 1 ||
                                    props?.SingleMovement?.statusId === 2 ? (
                                    <i
                                        className="fas fa-times"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => props.handleRemoveMovementProductLine(id)}
                                    />
                                ) : null}
                            </td>
                        </tr>
                    );
                });
        }
    };

    return (
        <Card className="strpied-tabled-with-hover">
            <Card.Header>
                <Row className="d-flex">
                    <Card.Title as="h4">Movements Products</Card.Title>
                    <Col style={SearchStyle}>
                        <CustomSearchBox
                            placeholder="Search"
                            value={props.search}
                            handleChange={(e) => props.handleSearchChange(e)}
                            handleClear={() => props.handleSearchChange("")}
                        />
                    </Col>
                    <Col style={{ "marginTop": "-22px" }}>
                        <Form.Check
                            defaultChecked
                            onChange={() => setSummaryView(!summaryView)}
                            type="switch"
                        />
                        <h5 className="archived" style={{ width: "119px" }}>
                            Summary View
                        </h5>
                    </Col>
                    <Col>
                        {getPermission(props.userPermissions, MOVEMENTS_MASS_BOOK_IN) && (
                            <OverlayTrigger
                                href="#pablo"
                                onClick={(e) => e.preventDefault()}
                                overlay={<Tooltip id="tooltip-255158527">Mass Book In</Tooltip>}
                            >
                                <Button
                                    // style={SearchStyle}
                                    style={btnStyle}
                                    className="btn-fill"
                                    variant="primary"
                                    onClick={() => props.handleMassBookIn(props.SingleMovement.id)}
                                >
                                    Mass Book In
                                </Button>
                            </OverlayTrigger>
                        )}
                        {props.SingleMovement.typeId === 3 && (
                            <OverlayTrigger
                                href="#pablo"
                                onClick={(e) => e.preventDefault()}
                                overlay={
                                    <Tooltip id="tooltip-255158527">Add Movement Product</Tooltip>
                                }
                            >
                                <Button
                                    style={SearchStyle}
                                    className="btn-fill float-end"
                                    variant="primary"
                                    onClick={() => props.handleAddMovementProduct()}
                                >
                                    Add
                                </Button>
                            </OverlayTrigger>
                        )}
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="table-responsive p-0">
                {props.isLoading ? (
                    <div
                        style={{ height: 120 }}
                        className="d-flex justify-content-center align-items-center text-center"
                    >
                        <div>
                            <Spinner animation="border" />
                            <p>Loading...</p>
                        </div>
                    </div>
                ) : (
                    <>
                        {props.MovementsProductData &&
                            props.MovementsProductData.length == 0 && (
                                <p
                                    style={{ height: 120 }}
                                    className="d-flex justify-content-center align-items-center text-center"
                                >
                                    No data found.
                                </p>
                            )}
                    </>
                )}
                {props.MovementsProductData.length !== 0 && !props.isLoading && (
                    <Col md="20">
                        <Table className="table-hover table-striped w-full">
                            <thead>
                                <tr>
                                    <th>Sku</th>
                                    <th>Product Name</th>
                                    <th>Quantity</th>
                                    <th>Picked</th>
                                    <th>Booked Out</th>
                                    <th>Recieved</th>
                                    <th>Booked In</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>{renderTableData()}</tbody>
                        </Table>
                    </Col>
                )}
            </Card.Body>
        </Card>
    );
}
export default MovementsProductTable;
